var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FscModal',{attrs:{"modal-id":_vm.modalId},on:{"ok":_vm.ok}},[_c('span',{staticClass:"font-weight-bold font-size-18"},[_vm._v(" "+_vm._s(_vm.$t("general.send_password_again"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }